export { default as CmsTwoColumnSplit } from './lib/cms-two-column-split';
